import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { DataKey } from '../../../../../../shared/models/panel'
import _ from 'lodash'
import dayjs from 'dayjs'
import { formatValue, isNumericValue } from '../../../../../../utils/utils'

export interface TimeSeriesTableType {
  ts: number
  [key: string]: number
}

const getColumns = (keys?: DataKey[]) => {
  const columnHelper = createColumnHelper<TimeSeriesTableType>()
  const columns: ColumnDef<TimeSeriesTableType, any>[] = [
    columnHelper.accessor((row) => row.ts, {
      id: 'ts',
      cell: (info) =>
        info.getValue()
          ? dayjs(info.getValue()).format('DD-MM-YYYY HH:mm:ss')
          : '',
      header: () => 'Réception',
      enableSorting: true,
    }),
  ]
  _.forEach(keys, (key) => {
    columns.push(
      columnHelper.accessor((row) => row[key.key], {
        id: key.key,
        cell: (info) => {
          if (info.getValue() === null || info.getValue() === undefined) {
            return 'Valeur manquante'
          }
          if (isNumericValue(info.getValue())) {
            return formatValue(info.getValue(), 2, key.units, false)
          }
          if (typeof info.getValue() === 'string') {
            return info.getValue()
          }
          if (typeof info.getValue() === 'boolean') {
            return info.getValue() ? 'Oui' : 'Non'
          }
          if (typeof info.getValue() === 'object') {
            return JSON.stringify(info.getValue())
          }
          return 'Valeur de type  inconnue'
        },
        header: () => key.label,
        enableSorting: true,
      })
    )
  })

  return columns
}

export default getColumns
